export default class LinkTextOverrideResponseHandler {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    doesHandle(response) {
        return response.messageType === this._settings.messageConstants.converseRequest ||
            response.messageType === this._settings.messageConstants.requestUnitRequest ||
            response.messageType === this._settings.messageConstants.appeventRequest ||
            response.messageType === this._settings.messageConstants.getHistoryRequest;
    }

    process(message) {
        if (!this.doesHandle(message)) return message;
        if (this.isArrayOfMessages(message)) return this.handleArrayOfMessages(message);

        message.response = this.processResponse(message.response);

        return message;
    }

    processResponse(response) {
        if (!response) return response;

        // update navurl text
        if (this.containsNavLink(response)) {
            if (!response.navUrl.Metadata?.Download && response.navUrl.DisplayText != "") {
                response.navUrl.DisplayText = this._settings.textConstants.viewPageLinkText;
            }
        }

        // update display links text
        if (this.containsDisplayLinks(response)) {
            response.displayLinkCollection.Sections.forEach((section) => {
                if (section.FoldText) section.FoldText = this._settings.textConstants.moreLinksText;
                if (section.HeaderText) section.HeaderText = this._settings.textConstants.displayLinksHeaderText;
            });
        }

        return response;
    }

    isArrayOfMessages( message ) {
        return Array.isArray(message.response);
    }

    handleArrayOfMessages( message ) {
        for (var i = 0, len = message.response.length; i < len; i++) {
            message.response[i] = this.processResponse(message.response[i]);
        }
        return message;
    }

    containsNavLink(response) {
        if (response && response.navUrl) {
            return response.navUrl.UrlAddress !== undefined;
        }
        return false;
    }

    containsDisplayLinks(response) {
        if (response && response.displayLinks) {
            return response.displayLinks.length > 0;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/language-specific-settings-override/src/response-handler-links.js